import React, { FC } from 'react';
import { useClsSummarizingTypeQuery } from '../api';
import { Select } from '../components/Inputs';
import { ControllerProps } from 'react-hook-form/dist/types/props';

interface SummarizingType extends Pick<ControllerProps<'input'>, 'control' | 'name' | 'rules'> {
  label: string;
  error: boolean | undefined;
  disabled?: boolean;
}

const SummarizingType: FC<SummarizingType> = ({ label, error, control, name, rules, disabled }) => {
  const { data } = useClsSummarizingTypeQuery();
  return (
    <Select
      label={label}
      data={(data && data.classifierValues) || []}
      control={control}
      error={error}
      name={name}
      rules={rules}
      disabled={disabled}
    />
  );
};

export default SummarizingType;
